import { useCallback, useEffect, useState } from "react";
import { useAuth } from "../AuthContext";
import Lobby from "./Lobby";
import Room from "./Room";
import { useParams } from "react-router-dom";
import { SessionSettingsResponse } from "./types";

const Meeting = () => {
    const { user } = useAuth();
    const { roomId = "" } = useParams<{ roomId: string }>();
    const [displayLobby, setDisplayLobby] = useState<boolean>(true);
    const [lobbyResponse, setLobbyResponse] = useState<SessionSettingsResponse | null>(null);
    const [selectedAvatarId, setSelectedAvatarId] = useState<string | null>(null);
    const [sessionIdentityKey, setSessionIdentityKey] = useState<string | null>(null);

    const onFinishConfiguration = useCallback(async (validationResponse: SessionSettingsResponse, avatarId: string | null, identityKey: string | null) => {
        if (!validationResponse) return;

        setDisplayLobby(false);
        setLobbyResponse(validationResponse);
        setSelectedAvatarId(avatarId);
        setSessionIdentityKey(identityKey);
    }, []);

    if (displayLobby) {
        return <Lobby
            user={user}
            roomId={roomId}
            onFinishConfiguration={onFinishConfiguration} 
        />;
    }

    return <Room
        user={user}
        roomId={roomId}
        sessionSetting={lobbyResponse}
        selectedAvatarId={selectedAvatarId}
        sessionIdentityKey={sessionIdentityKey}
    />;
};

export default Meeting;